import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import { globals } from './globals';
import { getSkyfireEnvironment } from './getSkyfireEnvironment';
import { getNodeEnvironment } from './getNodeEnvironment';
const API_KEY = '26b95077fec20f86665fb2529425f30b';
const SESSION_ENDPOINT = 'https://session.app-performance.music.amazon.dev';
const NOTIFICATION_ENDPOINT = 'https://events.app-performance.music.amazon.dev';
const PERFORMANCE_ENDPOINT = 'https://trace.app-performance.music.amazon.dev/v1/traces';
export function initBugsnag() {
    const { amznMusic } = globals;
    const appConfig = amznMusic === null || amznMusic === void 0 ? void 0 : amznMusic.appConfig;
    Bugsnag.start({
        onError(event) {
            event.addMetadata('Account', {
                skyfireEnv: getSkyfireEnvironment(),
                subscription: appConfig === null || appConfig === void 0 ? void 0 : appConfig.tier,
                territory: appConfig === null || appConfig === void 0 ? void 0 : appConfig.musicTerritory,
                sessionId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.sessionId,
                deviceId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.deviceId,
                siteRegion: appConfig === null || appConfig === void 0 ? void 0 : appConfig.siteRegion,
                deviceType: appConfig === null || appConfig === void 0 ? void 0 : appConfig.deviceType,
                isInContainerApp: amznMusic === null || amznMusic === void 0 ? void 0 : amznMusic.isInContainerApp,
            });
        },
        apiKey: API_KEY,
        plugins: [new BugsnagPluginReact()],
        endpoints: {
            notify: NOTIFICATION_ENDPOINT,
            sessions: SESSION_ENDPOINT,
        },
        appVersion: appConfig === null || appConfig === void 0 ? void 0 : appConfig.version,
        releaseStage: getNodeEnvironment(),
    });
    BugsnagPerformance.start({
        apiKey: API_KEY,
        endpoint: PERFORMANCE_ENDPOINT,
        sendPageAttributes: {
            url: true,
            title: true,
            referrer: true,
        },
        appVersion: appConfig === null || appConfig === void 0 ? void 0 : appConfig.version,
        releaseStage: getNodeEnvironment(),
    });
    const bugsnagReactPlugin = Bugsnag.getPlugin('react');
    return (bugsnagReactPlugin === null || bugsnagReactPlugin === void 0 ? void 0 : bugsnagReactPlugin.createErrorBoundary(React)) || React.Fragment;
}
